<script>
import PendingPayablesList from "./PendingPayablesList";
import OrderCard from "@/components/Order/Components/Card/Index";
import CycleCard from "@/components/Cycle/Components/Card";

export default {
  components: {
    OrderCard,
    CycleCard,
    PendingPayablesList
  },

  props: {
    pendingOrders: {
      type: Array,
      required: true
    },
    pendingCycles: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    totalPendingPayables: function() {
      return this.pendingOrders.length + this.pendingCycles.length;
    },

    pendingCyclesToShow: function() {
      return !this.pendingOrders.length
        ? this.pendingCycles.slice(0, 2)
        : this.pendingCycles.slice(0, 1);
    },

    pendingOrdersToShow: function() {
      return !this.pendingCycles.length
        ? this.pendingOrders.slice(0, 2)
        : this.pendingOrders.slice(0, 1);
    }
  }
};
</script>

<template>
  <transition name="down" mode="out-in">
    <div class="pending-payments" v-if="totalPendingPayables">
      <div class="header">
        Pagamentos pendentes ({{ totalPendingPayables }})
      </div>

      <div class="body">
        <CycleCard
          v-for="cycle in pendingCyclesToShow"
          :key="cycle.id"
          :payable="cycle"
        />

        <OrderCard
          v-for="order in pendingOrdersToShow"
          :key="order.id"
          :payable="order"
        />
      </div>

      <button class="btn bg-purple" v-if="totalPendingPayables > 2" @click="open = true">
        Ver todos
      </button>

      <PendingPayablesList
        v-if="open"
        @close="open = false"
        :cycles="pendingCycles"
        :orders="pendingOrders"
      />
    </div>
  </transition>
</template>

<style scoped>
.pending-payments {
  padding: 12px;
  background-color: #fff;
  border-radius: 2px;
  transition-delay: 500ms;
}

.header {
  margin-bottom: 8px;
  font-weight: 400;
  color: #424242;
}

button {
  width: calc(100% + 24px);
  margin: 16px -12px -12px -12px;
  border-radius: 2px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/PendingPayables.vue